import { Button, Grid, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { AddCircle } from '@mui/icons-material';
import { useState } from 'react';
import { MemberProfileTabNavigation } from './memberProfileTabNavigation';
import { CreateMemberProfileGroup } from './createMemberProfileGroup';

export const MemberProfileLayout = () => {
  const { t } = useTranslation();
  const [createProfileGroupModal, setCreateProfileGroupModal] = useState<boolean>(false);

  return (
    <GridWrapper>
      <Grid item xs={12} md={4}>
        <MainContentHeader title={t('memberProfile:pageTitle')} />
      </Grid>
      <Grid item xs={12} md={8} style={{ display: 'flex', justifyContent: 'flex-end', gridColumnGap: '5px' }}>
        <Button onClick={() => setCreateProfileGroupModal(true)} variant='contained' color='primary' startIcon={<AddCircle />} disableElevation>
          {t('memberProfile:profileGroupPage.createProfileGroup')}
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <MemberProfileTabNavigation />
          <Outlet />
        </Paper>
      </Grid>
      {createProfileGroupModal && <CreateMemberProfileGroup onClose={() => setCreateProfileGroupModal(false)} modalOpen={createProfileGroupModal} />}
    </GridWrapper>
  );
};
